export default "__VITE_ASSET__B161y0z8__"